<template>
  <van-popup v-model="showPage" position="bottom" @closed="onClosed">
    <van-row class="popTitle">
      <van-col span="4" />
      <van-col span="16" class="center" :style="'color:'+GetDiveMainBack()">评分详情</van-col>
      <van-col span="4" class="rigth"><i class="iconfont iconrigthjt" @click="showPage=false" /></van-col>
    </van-row>
    <div class="backRect">
      <van-skeleton title :row="10" :loading="loading">
        <div v-if="data" class="TopLine">
          <div class="iconRect">
            <van-image
              width="5em"
              height="5em"
              round
              fit="contain"
              :src="data.userIcon?data.userIcon:'/dive/defaultIcon.jpg'"
            />
          </div>
          <div class="bodyRect">
            <van-rate v-if="data.isScore" v-model="data.score" size="0.9em" readonly class="star" :color="GetDiveMainBack()" />
            <div class="names">{{ data.userName }}</div>
          </div>
        </div>
        <div v-if="data" class="scoreRect">
          <van-row v-for="(item,index) in data.baseScore" :key="index" class="rateBar">
            <van-col span="6" class="title"><span>{{ getConfigName(item.location) }}</span></van-col>
            <van-col span="18">
              <van-rate v-model="item.score" class="rate" :color="GetDiveMainBack()" readonly void-icon="star" void-color="#eee" />
              <div class="starAbout">
                <span>{{ getScoreText(item.score) }}</span>
              </div>
              <br>

            </van-col>
            <van-col span="18" offset="6">
              <div class="tagRect">
                <van-tag v-for="(tag,i) in item.tag" :key="i" class="tag" round :color="GetDiveMainBack()">  {{ tag }}</van-tag>
                <van-tag v-for="(tag,i) in item.tagBadly" :key="i" class="tag" round plain :color="GetDiveMainBack()">  {{ tag }}</van-tag>
              </div>
            </van-col>
          </van-row>
        </div>
        <div v-if="data" class="aboutRect">
          评论内容:{{ data.about }}<br>
          <van-image
            v-for="(img,index) in data.res"
            :key="index"
            class="img"
            width="2.5em"
            height="2.5em"
            fit="cover"
            lazy-load
            :src="img"
            radius="0.3em"
            @click="showPreview(data.res)"
          />
        </div>
      </van-skeleton>
    </div>
  </van-popup>
</template>
<script>
import request from '@/utils/request'
import { Button, Popup, Image, Lazyload, Rate, Tag, Skeleton, ImagePreview } from 'vant'
import { getScoreText, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import { getDiveCommentConfigList } from '@/utils/baseData'
// import { formatDate } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Image.name]: Image,
    [Rate.name]: Rate,
    [Lazyload.name]: Lazyload,
    [Tag.name]: Tag,
    [Skeleton.name]: Skeleton,
    [ImagePreview.name]: ImagePreview
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: String,
    // eslint-disable-next-line vue/require-default-prop
    commentType: String
  },
  data() {
    return {
      showPage: false,
      commentId: undefined,
      data: undefined,
      loading: true,
      configList: []

    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.data = undefined
        this.loading = true
        this.showPage = true
        this.commentId = newValue
        getDiveCommentConfigList((data) => {
          this.configList = data
          this.init()
        })
      } else {
        this.showPage = false
        this.commentId = undefined
      }
    }

  },
  created() {
  },
  methods: {
    getDiveCommentConfigList,
    getScoreText,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetColorMainLine,
    onClosed() {
      this.$emit('input', undefined)
    },
    getConfigName(location) {
      var result = this.configList.filter(m => m.type === this.commentType && m.location === location)
      if (result.length > 0) {
        return result[0].name
      }
      return null
    },
    showPreview(imgs) {
      ImagePreview(imgs)
    },
    init() {
      request({
        url: '/DiveData/getDiveComment',
        method: 'post',
        data: {
          type: this.commentType,
          commentId: this.commentId
        }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
      })
    }
  }
}
</script>

<style scoped>
.popTitle
{
  padding: 0.5em 0.5em;
  border-bottom: 1px solid #f5f5f5;
}

.backRect{
  padding:1em;

}
.backRect .TopLine{
  position: relative;
}
.backRect .TopLine .bodyRect{
  position: absolute;
  left: 6em;
  top: 1em;
}
.backRect .TopLine .bodyRect .names{
  font-size: 0.9em;
  padding: 0.5em 0;
}

.rateBar{
  padding: 0.25em 0;
}
.rateBar .title span{
  font-size: 0.8em;
}
.rateBar .rate
{
    float: left;
}
.rateBar .starAbout{
  float: left;
  margin-left: 0.5em;
}
.rateBar .starAbout span{
    font-size: 0.8em;
    color: #999;
}
.tagRect .tag{
  margin: 0.25em;
}

.aboutRect
{
  padding: 0.25em 0;
  font-size: 0.8em;
  color: #999;
  margin-top: 1em;
  border-top: 1px solid #f5f5f5;
  padding-top: 1em;
}

.aboutRect .img{
  margin:0.5em 0.5em 0 0;
  overflow: hidden;
}
</style>
